import { Amplify } from 'aws-amplify';
import awsconfig from '../aws-exports';

// Configure Amplify once at startup with the current origin as the redirect URL.
// This works for both https://calculus.7advisors.com and http://localhost:3000
// as long as both are in the Cognito app client's allowed callback URLs.
const redirectUrl = window.location.origin + '/';

Amplify.configure({
  ...awsconfig,
  oauth: {
    ...awsconfig.oauth,
    redirectSignIn: redirectUrl,
    redirectSignOut: redirectUrl,
    responseType: 'code',
  },
});
